// removed by extract-text-webpack-plugin
module.exports = {"headline":"src-styles----university-module---headline---3gC46"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/university.module.css
// module id = 206
// module chunks = 165208297294940 191283472321578